import { render, staticRenderFns } from "./TurnoEstado.vue?vue&type=template&id=40a3c492"
import script from "./TurnoEstado.vue?vue&type=script&lang=js"
export * from "./TurnoEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports